<yc-modal *ngIf="templateId"
  [modalHeader]="'common:lblPreview' | ycI18n: 'Preview'"
  [primaryButtonText]="'common:textClose' | ycI18n: 'Close'"
  (onPrimaryClick)="closeModal.emit()"
  (onCancel)="closeModal.emit()">

  <gc-merge-document-preview
    [applicationIds]="applicationIds"
    [templateId]="templateId">
  </gc-merge-document-preview>
</yc-modal>